import { PageHeader } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { MusicManager } from '../views/MusicManager';

/** Background-music section (promoted from the floating BGM panel). */
export function MusicSection() {
  const ctx = useBinder();
  if (!ctx) return null;
  return (
    <div>
      <PageHeader eyebrow="Musica" title="Colonna sonora" />
      <MusicManager slug={ctx.slug} />
    </div>
  );
}
